// US Cities by State (main cities)
export const US_CITIES = {
  'FL': [
    'Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'West Palm Beach',
    'Hialeah', 'St. Petersburg', 'Tallahassee', 'Port St. Lucie', 'Cape Coral',
    'Pembroke Pines', 'Hollywood', 'Gainesville', 'Miramar', 'Coral Springs',
    'Miami Gardens', 'Clearwater', 'Palm Bay', 'Pompano Beach', 'Lakeland',
    'Davie', 'Boca Raton', 'Sunrise', 'Plantation', 'Doral', 'Miami Beach',
    'Fort Myers', 'Deltona', 'Kissimmee', 'Homestead', 'Boynton Beach',
    'Deerfield Beach', 'Lauderhill', 'Tamarac', 'Weston', 'Palm Coast',
    'Ocala', 'Delray Beach', 'Sarasota', 'Bradenton', 'Aventura', 'Coconut Creek', 'Davenport'
  ],
  'TX': [
    'Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso',
    'Arlington', 'Corpus Christi', 'Plano', 'Laredo', 'Lubbock', 'Garland',
    'Irving', 'Frisco', 'McKinney', 'Amarillo', 'Grand Prairie', 'Brownsville',
    'Killeen', 'Pasadena', 'Mesquite', 'McAllen', 'Denton', 'Midland',
    'Carrollton', 'Round Rock', 'Waco', 'Abilene', 'Odessa', 'Richardson',
    'Pearland', 'Sugar Land', 'College Station', 'Lewisville', 'Tyler', 'League City'
  ],
  'CA': [
    'Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno', 'Sacramento',
    'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim', 'Santa Ana', 'Riverside',
    'Stockton', 'Irvine', 'Chula Vista', 'Fremont', 'San Bernardino', 'Modesto',
    'Fontana', 'Moreno Valley', 'Glendale', 'Huntington Beach', 'Santa Clarita',
    'Garden Grove', 'Oceanside', 'Rancho Cucamonga', 'Santa Rosa', 'Ontario',
    'Elk Grove', 'Corona', 'Lancaster', 'Palmdale', 'Salinas', 'Pomona', 'Hayward'
  ],
  'NY': [
    'New York City', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany',
    'New Rochelle', 'Mount Vernon', 'Schenectady', 'Utica', 'White Plains',
    'Hempstead', 'Troy', 'Niagara Falls', 'Binghamton', 'Freeport', 'Valley Stream',
    'Long Beach', 'Ithaca', 'Poughkeepsie', 'Staten Island', 'Brooklyn', 'Queens',
    'Manhattan', 'Bronx', 'Westchester'
  ],
  'NJ': [
    'Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Woodbridge',
    'Lakewood', 'Toms River', 'Hamilton', 'Trenton', 'Clifton', 'Camden',
    'Brick', 'Cherry Hill', 'Passaic', 'Union City', 'Old Bridge', 'Middletown',
    'Bayonne', 'East Orange', 'North Bergen', 'Vineland', 'Hoboken'
  ],
  'MA': [
    'Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell', 'Brockton',
    'New Bedford', 'Quincy', 'Lynn', 'Fall River', 'Newton', 'Lawrence',
    'Somerville', 'Framingham', 'Haverhill', 'Malden', 'Brookline', 'Medford', 'Vineyard Haven'
  ],
  'GA': [
    'Atlanta', 'Augusta', 'Columbus', 'Macon', 'Savannah', 'Athens', 'Sandy Springs',
    'Roswell', 'Johns Creek', 'Albany', 'Warner Robins', 'Alpharetta', 'Marietta',
    'Valdosta', 'Smyrna', 'Dunwoody', 'Rome', 'Peachtree City', 'Douglasville'
  ],
  'IL': [
    'Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield',
    'Elgin', 'Peoria', 'Champaign', 'Waukegan', 'Cicero', 'Bloomington',
    'Arlington Heights', 'Evanston', 'Decatur', 'Schaumburg', 'Bolingbrook'
  ],
  'PA': [
    'Philadelphia', 'Pittsburgh', 'Allentown', 'Reading', 'Scranton', 'Bethlehem',
    'Lancaster', 'Harrisburg', 'Altoona', 'Erie', 'York', 'Wilkes-Barre',
    'Chester', 'State College'
  ],
  'OH': [
    'Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton',
    'Parma', 'Canton', 'Youngstown', 'Lorain', 'Hamilton', 'Springfield'
  ],
  'AZ': [
    'Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale', 'Gilbert',
    'Tempe', 'Peoria', 'Surprise', 'Yuma', 'Avondale', 'Goodyear', 'Flagstaff'
  ],
  'NC': [
    'Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville',
    'Cary', 'Wilmington', 'High Point', 'Asheville', 'Greenville', 'Concord'
  ],
  'MI': [
    'Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Ann Arbor', 'Lansing',
    'Flint', 'Dearborn', 'Livonia', 'Troy', 'Westland', 'Farmington Hills'
  ],
  'WA': [
    'Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Kent', 'Everett',
    'Renton', 'Federal Way', 'Spokane Valley', 'Kirkland', 'Bellingham'
  ],
  'CO': [
    'Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Thornton',
    'Arvada', 'Westminster', 'Pueblo', 'Centennial', 'Boulder', 'Greeley'
  ],
  'NV': [
    'Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks', 'Carson City'
  ],
  'MD': [
    'Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie', 'Hagerstown',
    'Annapolis', 'College Park', 'Salisbury', 'Laurel', 'Silver Spring', 'Bethesda'
  ],
  'VA': [
    'Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News',
    'Alexandria', 'Hampton', 'Roanoke', 'Portsmouth', 'Suffolk', 'Lynchburg',
    'Arlington', 'Fairfax', 'Manassas'
  ],
  'CT': [
    'Bridgeport', 'New Haven', 'Stamford', 'Hartford', 'Waterbury', 'Norwalk',
    'Danbury', 'New Britain', 'Bristol', 'Meriden', 'West Hartford', 'Greenwich'
  ],
  'AL': ['Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa', 'Hoover'],
  'AK': ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan'],
  'AR': ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro'],
  'DE': ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
  'HI': ['Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Waipahu'],
  'ID': ['Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello'],
  'IN': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers'],
  'IA': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City'],
  'KS': ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe'],
  'KY': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington'],
  'LA': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
  'ME': ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn'],
  'MN': ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington'],
  'MS': ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi'],
  'MO': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence'],
  'MT': ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte'],
  'NE': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney'],
  'NH': ['Manchester', 'Nashua', 'Concord', 'Derry', 'Dover'],
  'NM': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell'],
  'ND': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo'],
  'OK': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond'],
  'OR': ['Portland', 'Salem', 'Eugene', 'Gresham', 'Hillsboro', 'Beaverton'],
  'RI': ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence'],
  'SC': ['Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill', 'Greenville'],
  'SD': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown'],
  'TN': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville', 'Murfreesboro'],
  'UT': ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem'],
  'VT': ['Burlington', 'Essex', 'South Burlington', 'Rutland', 'Barre'],
  'WV': ['Charleston', 'Huntington', 'Morgantown', 'Parkersburg', 'Wheeling'],
  'WI': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton'],
  'WY': ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs']
};

// Brazilian Cities by State (capitals and major cities)
export const BR_CITIES = {
  'SP': [
    'São Paulo', 'Guarulhos', 'Campinas', 'São Bernardo do Campo', 'Santo André',
    'Osasco', 'Sorocaba', 'Ribeirão Preto', 'Santos', 'São José dos Campos',
    'Mauá', 'São José do Rio Preto', 'Piracicaba', 'Mogi das Cruzes', 'Bauru',
    'Diadema', 'Jundiaí', 'Carapicuíba', 'Franca', 'Itaquaquecetuba',
    'Praia Grande', 'São Vicente', 'Taubaté', 'Americana', 'Limeira',
    'Sumaré', 'Marília', 'Araraquara', 'São Carlos', 'Jacareí', 'Indaiatuba'
  ],
  'RJ': [
    'Rio de Janeiro', 'São Gonçalo', 'Duque de Caxias', 'Nova Iguaçu', 'Niterói',
    'Belford Roxo', 'São João de Meriti', 'Campos dos Goytacazes', 'Petrópolis',
    'Volta Redonda', 'Magé', 'Itaboraí', 'Macaé', 'Cabo Frio', 'Angra dos Reis',
    'Nova Friburgo', 'Teresópolis', 'Barra Mansa', 'Resende', 'Búzios'
  ],
  'MG': [
    'Belo Horizonte', 'Uberlândia', 'Contagem', 'Juiz de Fora', 'Betim',
    'Montes Claros', 'Ribeirão das Neves', 'Uberaba', 'Governador Valadares',
    'Ipatinga', 'Sete Lagoas', 'Divinópolis', 'Santa Luzia', 'Poços de Caldas',
    'Patos de Minas', 'Pouso Alegre', 'Barbacena', 'Araguari', 'Lavras', 'Ouro Preto'
  ],
  'BA': [
    'Salvador', 'Feira de Santana', 'Vitória da Conquista', 'Camaçari', 'Itabuna',
    'Juazeiro', 'Lauro de Freitas', 'Ilhéus', 'Jequié', 'Teixeira de Freitas',
    'Barreiras', 'Alagoinhas', 'Porto Seguro', 'Simões Filho', 'Paulo Afonso'
  ],
  'RS': [
    'Porto Alegre', 'Caxias do Sul', 'Pelotas', 'Canoas', 'Santa Maria',
    'Gravataí', 'Viamão', 'Novo Hamburgo', 'São Leopoldo', 'Rio Grande',
    'Alvorada', 'Passo Fundo', 'Sapucaia do Sul', 'Uruguaiana', 'Cachoeirinha',
    'Bagé', 'Santa Cruz do Sul', 'Bento Gonçalves', 'Gramado', 'Torres'
  ],
  'PR': [
    'Curitiba', 'Londrina', 'Maringá', 'Ponta Grossa', 'Cascavel', 'São José dos Pinhais',
    'Foz do Iguaçu', 'Colombo', 'Guarapuava', 'Paranaguá', 'Araucária',
    'Toledo', 'Apucarana', 'Pinhais', 'Campo Largo', 'Umuarama'
  ],
  'SC': [
    'Florianópolis', 'Joinville', 'Blumenau', 'São José', 'Chapecó',
    'Criciúma', 'Itajaí', 'Jaraguá do Sul', 'Palhoça', 'Lages',
    'Balneário Camboriú', 'Brusque', 'Tubarão', 'São Bento do Sul', 'Navegantes'
  ],
  'PE': [
    'Recife', 'Jaboatão dos Guararapes', 'Olinda', 'Caruaru', 'Petrolina',
    'Paulista', 'Cabo de Santo Agostinho', 'Camaragibe', 'Garanhuns', 'Vitória de Santo Antão'
  ],
  'CE': [
    'Fortaleza', 'Caucaia', 'Juazeiro do Norte', 'Maracanaú', 'Sobral',
    'Crato', 'Itapipoca', 'Maranguape', 'Iguatu', 'Quixadá'
  ],
  'GO': [
    'Goiânia', 'Aparecida de Goiânia', 'Anápolis', 'Rio Verde', 'Luziânia',
    'Águas Lindas de Goiás', 'Valparaíso de Goiás', 'Trindade', 'Formosa', 'Catalão'
  ],
  'PA': [
    'Belém', 'Ananindeua', 'Santarém', 'Marabá', 'Castanhal',
    'Parauapebas', 'Abaetetuba', 'Cametá', 'Bragança', 'Marituba'
  ],
  'MA': [
    'São Luís', 'Imperatriz', 'São José de Ribamar', 'Timon', 'Caxias',
    'Codó', 'Paço do Lumiar', 'Açailândia', 'Bacabal', 'Balsas'
  ],
  'AM': [
    'Manaus', 'Parintins', 'Itacoatiara', 'Manacapuru', 'Coari',
    'Tefé', 'Tabatinga', 'Maués', 'Iranduba'
  ],
  'PB': [
    'João Pessoa', 'Campina Grande', 'Santa Rita', 'Patos', 'Bayeux',
    'Sousa', 'Cajazeiras', 'Cabedelo', 'Guarabira'
  ],
  'RN': [
    'Natal', 'Mossoró', 'Parnamirim', 'São Gonçalo do Amarante', 'Macaíba',
    'Ceará-Mirim', 'Caicó', 'Açu', 'Currais Novos'
  ],
  'MT': [
    'Cuiabá', 'Várzea Grande', 'Rondonópolis', 'Sinop', 'Tangará da Serra',
    'Cáceres', 'Sorriso', 'Lucas do Rio Verde', 'Primavera do Leste'
  ],
  'MS': [
    'Campo Grande', 'Dourados', 'Três Lagoas', 'Corumbá', 'Ponta Porã',
    'Naviraí', 'Nova Andradina', 'Aquidauana', 'Sidrolândia'
  ],
  'DF': [
    'Brasília', 'Taguatinga', 'Ceilândia', 'Samambaia', 'Planaltina',
    'Águas Claras', 'Gama', 'Sobradinho', 'Recanto das Emas'
  ],
  'ES': [
    'Vitória', 'Vila Velha', 'Serra', 'Cariacica', 'Cachoeiro de Itapemirim',
    'Linhares', 'Colatina', 'Guarapari', 'São Mateus'
  ],
  'AL': [
    'Maceió', 'Arapiraca', 'Rio Largo', 'Palmeira dos Índios', 'União dos Palmares',
    'Penedo', 'São Miguel dos Campos', 'Marechal Deodoro'
  ],
  'PI': [
    'Teresina', 'Parnaíba', 'Picos', 'Piripiri', 'Campo Maior',
    'Floriano', 'Barras', 'Altos'
  ],
  'SE': [
    'Aracaju', 'Nossa Senhora do Socorro', 'Lagarto', 'Itabaiana', 'São Cristóvão',
    'Estância', 'Tobias Barreto'
  ],
  'RO': [
    'Porto Velho', 'Ji-Paraná', 'Ariquemes', 'Vilhena', 'Cacoal',
    'Rolim de Moura', 'Jaru'
  ],
  'TO': [
    'Palmas', 'Araguaína', 'Gurupi', 'Porto Nacional', 'Paraíso do Tocantins'
  ],
  'AC': [
    'Rio Branco', 'Cruzeiro do Sul', 'Sena Madureira', 'Tarauacá', 'Feijó'
  ],
  'AP': [
    'Macapá', 'Santana', 'Laranjal do Jari', 'Oiapoque', 'Mazagão'
  ],
  'RR': [
    'Boa Vista', 'Rorainópolis', 'Caracaraí', 'Alto Alegre', 'Mucajaí'
  ]
};
